<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>广告位</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
      <!-- 搜索区域 -->
            <!-- 搜索和添加区域 -->
      <el-row :gutter="20">
        <el-col :span="9">
          <el-input placeholder="请输入搜索内容" v-model="queryInfo.query" class="input-with-select" clearable >
            <el-button slot="append" icon="el-icon-search" @click="getList"></el-button>
          </el-input>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="adduser()">添加</el-button>
        </el-col>
      </el-row>

      <!-- 列表区域 -->
      <el-table :data="list" border  style="width: 100%"  >       
        <el-table-column prop="id" label="id" width="50px"></el-table-column>
        <el-table-column prop="title" label="标题">           

          </el-table-column>        
        <el-table-column prop="imgsrc" label="图片"></el-table-column>      
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-button type="primary" size="mini" icon="el-icon-edit" @click="edituser(scope.row,scope.$index)">编辑</el-button>
            <!-- 删除按钮 -->
            <el-button type="danger" size="mini" icon="el-icon-delete" @click="deluser(scope.row,scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 10, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        class="center"
      >
      </el-pagination>
    </el-card>
<!-- 添加联系人对话框 -->
    <el-dialog title="编辑" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" ref="addFormRef" label-width="80px">
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="图片" prop="imgsrc">
          <el-input v-model="addForm.imgsrc" :disabled="true"></el-input>
           <el-upload
        class="upload-demo"
        :on-success="handle_success"
         :limit="1"
        :action="upurl"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :file-list="fileList"
        list-type="picture">
        <el-button size="small" type="primary">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
      </el-upload>

        </el-form-item>
      
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button @click="saveuser()" type="primary">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mqtt from 'mqtt'
import glob_Data from '@/public/global_data.js' //导入全局变量	
import {formatDate} from "@/common/tool.js"

export default {
  components: {},
  data() {
    return {    
     
      // 获取列表参数对象
      queryInfo: {
        query: '',
        // 当前的页数
        pagenum: 1,
        // 当前每页显示多少条数据
        pagesize: 10,
      },
      list: [
        
      ],
      value: true,
      total: 0, 
      // 控制添加用户对话框的显示或隐藏
      addDialogVisible: false,

      // 添加用户
      addForm: {
        index:-1,
        id:0,        
        title: '',
        imgsrc: '',
 
      },

      // 控制修改用户对话框的显示或隐藏
      editDialogVisible: false,

      // 查询到的用户
      editForm: {},
      fileList: [],
      upurl: glob_Data.globaldata.serverurl+"ctl_banner_ht.fsp?proc=upfile"
    }
  },
  async created() {        
      this.getList();
      this.upurl+="&token="+ localStorage.getItem("token");
  },
  methods: {
      handle_success(res){
       console.log(res);
       if(res.errno!=0){
         this.$message.warning(res.errmsg);
         this.fileList=[];
         return; 
       }

       this.addForm.imgsrc=res.filename
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handlePreview(file) {
        console.log(file);
      },
    saveuser(){
         let _this = this
         var serverurl = glob_Data.globaldata.serverurl;
         let url = serverurl+"ctl_banner_ht.fsp?proc=save";                
         url+="&token="+ localStorage.getItem("token");        
         console.log(url) ;

       if(!_this.addForm.imgsrc){
          _this.$alert("请上传图片","系统提示");
          return;
       }

        var sendata=this.addForm;
        this.$http({
          method: "post",//指定请求方式
          url: url,
          data:sendata          
        })
        .then(function(res){
          //接口成功返回结果执行
          if (res.data.errno!=0){
           _this.$alert(res.data.errmsg, '系统提示');          
           return;
          }          
          _this.fileList=[];
          if (_this.addForm.index!=-1){
             //_this.list[_this.addForm.index]=res.data.rows[0];
             _this.list.splice(_this.addForm.index,1,res.data.rows[0])
          }else{
            _this.list.push(res.data.rows[0])
          }
            _this.addDialogVisible = false
        })
        .catch(function(err){
            //请求失败或者接口返回失败或者.then()中的代码发生错误时执行
             _this.$alert(err, '系统错误');     
        })   
    },  
    deluser(item,index){
         let _this = this;
        this.$confirm('是否确认删除当前行？', '确认信息', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确认',
          cancelButtonText: '放弃'
        })
          .then(() => {
                console.log("fff");
                var serverurl = glob_Data.globaldata.serverurl;
                let url = serverurl+"ctl_banner_ht.fsp?proc=save";  
                url+="&token="+ localStorage.getItem("token");                        
                var senddata=item;
                senddata.qystatus="del"
                this.$http({
                  method: "post",//指定请求方式
                  url: url,
                  data:senddata          
                })
                .then(function(res){
                  //接口成功返回结果执行
                  if (res.data.errno!=0){
                  _this.$alert(res.data.errmsg, '系统提示');          
                  return;
                  }
                  _this.list.splice(index,1);
                  _this.$message({
                    type: 'info',
                    message: '删除成功'
                  });
                })
                .catch(function(err){
                    //请求失败或者接口返回失败或者.then()中的代码发生错误时执行
                    _this.$alert(err, '系统错误');     
                })   

          })
          .catch(action => {  
          });     
     
    },
    adduser(){
       this.addForm.index=-1;      
       this.addForm.title="";
       this.addForm.imgsrc="";       
       this.addDialogVisible=true;
    },
    edituser(item,index){
       console.log(index);
       this.addForm.index=index;      
       this.addForm.id=item.id;
       this.addForm.title=item.title;
       this.addForm.imgsrc=item.imgsrc;       
         
       this.addDialogVisible=true;
       console.log(this.addForm);
    },
    // 获取列表数据
        getList() {
            var serverurl = glob_Data.globaldata.serverurl;
            let url = serverurl+"ctl_banner_ht.fsp?proc=getlist"
            url+="&token="+ localStorage.getItem("token");        
          // Vue.prototype.$http = axios;
            var senddata={
              start:this.queryInfo.pagenum,
              limit:this.queryInfo.pagesize,
              query:this.queryInfo.query
            }
            let _this = this
            this.$http.get(url, {
            // emulateJSON:false,
              params:senddata
            }).then(function (res) {            
              if(res.data.errno!=0){
                  _this.$alert(res.data.errmsg,"系统提示");
                  return;
              }
                _this.list = res.data.rows;
                _this.total=res.data.total;
                var myrows=res.data.rows;              

            }).catch(function (error) {

            })
        },
        handleSizeChange(e) {
          console.log(e)
          this.queryInfo.pagesize=e;
          this.getUserList()
        },
        handleCurrentChange(e) {
          console.log(e)
          this.queryInfo.pagenum=e;
          this.getUserList()
        },
            //监听添加用户对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
       this.uplist=[];
        this.fileList=[];
    },  
      
    
  },
}
</script>
<style>

.table {
  width: 900px;
  height: 400px;
  margin: 100px auto;
}

/*更改表格颜色*/
.alert {
  background: #f9fd00 !important;
}
.zero {
  background: rgb(255, 255, 255) !important;
}
.notzero {
  background: rgb(128, 1, 1) !important;
}

</style>
